"use client";
import ContactUsForm from "@/components/contact-us-form";
import Image from "next/image";
import React from "react";
import { useLocale, useTranslations } from "next-intl";
import { cn } from "@/lib/utils";

export default function Page() {
  const t = useTranslations();
  const locale = useLocale();

  return (
    <main className="bg-white min-h-[calc(100vh-3.64rem)]  lg:min-h-[calc(100vh-4.5rem)]">
      <div className="w-full flex flex-col justify-center items-center py-10 pt-[3.64rem] lg:pt-[4.5rem]">
        <div
          className={cn("flex flex-col pt-12", {
            "gap-8": locale === "ar",
          })}
        >
          <h1 className="text-5xl md:text-7xl xl:text-8xl text-center font-[400] uppercase">
            {t("contact_us_content.get")}{" "}
            <span className="text-primary">
              {t("contact_us_content.in_touch")}
            </span>
          </h1>
          <p className="text-lg md:text-xl text-center font-poppins pb-6">
            <span className="block">{`${t(
              "contact_us_content.sub_title_first"
            )} ${locale === "ar" ? "جريتايزر" : "Gritizer"}`}</span>
            <span className="block">
              {t("contact_us_content.sub_title_second")}
            </span>
          </p>
        </div>

        <div className="w-11/12 md:w-3/4 lg:w-2/3 xl:w-3/4 bg-black-bg flex flex-col md:flex-row rounded-3xl m-10 h-full items-center justify-center ">
          <div className="basis-full md:basis-1/2 w-full p-4 md:p-6 text-start">
            <div
              className={cn(
                "flex flex-col gap-2 pb-8 text-center md:text-start",
                {
                  "gap-6": locale === "ar",
                }
              )}
            >
              <h2 className="text-5xl md:text-6xl xL:text-big-title  leading-[90px] text-primary-foreground uppercase">
                {t("contact_us_content.form.title")}
              </h2>
              <p className="text-base md:text-lg text-primary-foreground font-poppins pb-6">
                {t("contact_us_content.form.sub_title")}
              </p>
            </div>
            <ContactUsForm />
          </div>
          <div
            className={cn("md:basis-1/2 hidden md:block ", {
              "rounded-tl-3xl rounded-bl-3xl": locale === "ar",
              "rounded-tr-3xl rounded-br-3xl": locale === "en",
            })}
          >
            <Image
              src="/contact.webp"
              width={2000}
              height={2000}
              alt="Contact Form Illustration"
              className={cn("object-cover w-full h-full", {
                "rounded-tl-3xl rounded-bl-3xl": locale === "ar",
                "rounded-tr-3xl rounded-br-3xl": locale === "en",
              })}
            />
          </div>
        </div>
      </div>
    </main>
  );
}
